import {VideoSubEvent} from "../../../constants/Janus/VideoRoom/Subscriber";
import {PluginStatus} from "../../../constants/Janus";

interface SubscriberAction {
    type: VideoSubEvent,
    payload?: any
}

interface SubscriberState {
    remoteFeed: any;
    pluginStatus: PluginStatus;
    opaqueId: string;
    success: boolean;
    error: any;
    attached: boolean;
    event: any;
    iceState: string;
    webrtcState: boolean
    stream: any;
    cleanup: boolean;
}

export const initVideoSubState = {
    remoteFeed: null,
    pluginStatus: PluginStatus.None,
    opaqueId: "",
    success: false,
    error: undefined,
    attached: false,
    event: undefined,
    iceState: "",
    webrtcState: false,
    stream: null,
    cleanup: false
}

export const videoRoomSubReducer = (state: SubscriberState, {type, payload}: SubscriberAction) => {
    switch (type) {
        case VideoSubEvent.SUCCESS:
            return {
                ...state,
                success: true
            }
        case VideoSubEvent.ERROR:
            return {
                ...state,
                error: payload,
                cleanup: payload.error_code === 428 ? true : state.cleanup
            }
        case VideoSubEvent.ATTACHED:
            return {
                ...state,
                pluginStatus: PluginStatus.Attached
            }
        case VideoSubEvent.ICE_STATE:
            return {
                ...state,
                iceState: payload
            }
        case VideoSubEvent.WEBRTC_STATE:
            return {
                ...state,
                webrtcState: payload
            }
        case VideoSubEvent.ON_REMOTE_STREAM:
            return {
                ...state,
                stream: payload
            }
        case VideoSubEvent.ON_CLEAN_UP:
            return {
                ...state,
                cleanup: true
            }
        case VideoSubEvent.SET:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        default: {
            return state
        }
    }
}